import {useEffect, useState} from "react";
import {RcpStaticRecipe} from "./domain/RcpRecipe";
import {Link, useNavigate} from "react-router-dom";
import {getCsrfToken, setUserInfo} from "./App";

export function WebRecipeList() {
    const [recipes, setRecipes] = useState<RcpStaticRecipe[]>([]);
    let navigate = useNavigate();

    /**
     * Refresh the list data
     * @param force true to force a database refresh
     */
    function refreshListData(force: boolean) {
        getCsrfToken().then((token: string) => {
            fetch(`/api/v1/nutriRcp/listAllRecipes?force=${force}`, {
                method: "POST",
                headers: {"Content-Type": "application/json", "Accept": "application/json", "X-XSRF-TOKEN": token},
            }).then((response) => {
                if (response.status === 401 || response.status === 403) {
                    setUserInfo("Guest", "GUEST");
                    navigate("/login");
                } else if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json(); // Parse JSON response
            }).then((jsonData: any[]) => {
                let r = jsonData.map(r => RcpStaticRecipe.fromJson(r));
                if (r) setRecipes(r);
            })
        })
    }

    useEffect(() => {
        refreshListData(false);
    }, []);

    return (
        <div>
            <h1>Recipe List</h1>
            <button onClick={e => refreshListData(true)}>Force DB Refresh</button>
            <table>
                <thead>
                <tr>
                    <th>UUID</th>
                    <th>Status</th>
                    <th>Json Path</th>
                    <th>Markdown Path</th>
                </tr>
                </thead>
                <tbody>
                {recipes.map(r => <tr key={r.uuid}>
                    <td><Link to={`/rcpRecipe?id=${r.uuid}`}>{r.uuid}</Link></td>
                    <td>{r.status.name}</td>
                    <td>{r.jsonPath}</td>
                    <td>{r.markdownPath}</td>
                </tr>)
                }
                </tbody>
            </table>
        </div>
    );
}